<template>
	<tabbed-page-layout class="tracking" title="Tracking" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>